import { MdOutlineSchool } from "react-icons/md";

function addProps(dateStart, dateEnd) {
  return {
    category: "Education",
    dateEnd,
    dateStart,
    icon: <MdOutlineSchool />,
    stackType: "Tech",
  };
}

export const educationProjects = [
  {
    name: "Postss",
    about:
      "A social space where users socialize and engage in discussions with people worldwide.",
    stack:
      "React, Node, Express, Passport, SuperTest, TypeScript, Socket IO, Cloudinary, Tailwind CSS, Koyeb, Netlify",
    imgSrc: new URL(
      "../images/projects/education/postss-desktop-oluwatobi-sofela.png?as=webp&width=850",
      import.meta.url
    ),
    imgAlt: "Postss Social App's screenshot",
    link: "https://postss-social.netlify.app/",
    github: "https://github.com/oluwatobiss/postss-frontend",
    ...addProps(2025, 2025),
  },
  {
    name: "Pantry Picker",
    about:
      "A recipe app that allows users to search and explore a variety of recipes for one or more ingredients.",
    stack: "ReactJS, Vite, Tasty API, Playwright, GitHub Pages, Jira, Figma",
    imgSrc: new URL(
      "../images/projects/education/v46-tier2-team-17-oluwatobi-sofela.png?as=webp&width=850",
      import.meta.url
    ),
    imgAlt: "Pantry Picker's screenshot",
    link: "https://chingu-voyages.github.io/v46-tier2-team-17/",
    github: "https://github.com/chingu-voyages/v46-tier2-team-17",
    ...addProps(2023, 2023),
  },
  {
    name: "Dashboard",
    about:
      "A dashboard for an imaginary user (Morgan Oakley) who uses it to update himself on the latest CodeSweetly activities.",
    stack: "HTML, CSS",
    imgSrc: new URL(
      "../images/projects/education/dashboard-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "Dashboard project's screenshot",
    link: "https://oluwatobiss.github.io/dashboard-project",
    ...addProps(2022, 2022),
  },
  {
    name: "Melody",
    about:
      "Melody is a sign-up form for an imaginary musical service. Use it to register for the next musical event in town.",
    stack: "HTML, CSS, JavaScript",
    imgSrc: new URL(
      "../images/projects/education/melody-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "Melody project's screenshot",
    link: "https://oluwatobiss.github.io/melody-sign-up-form/",
    ...addProps(2022, 2022),
  },
  {
    name: "YouTube Clone",
    about:
      "YouTube Clone is a replication of the YouTube website. This replica implements most of the live website's functionality, like authentication, search, history, and shorts. So, you can use it to watch your favorite videos just as you would with the actual website.",
    stack: "Firebase, Jest, ReactJS, Testing Library, YouTube API",
    imgSrc: new URL(
      "../images/projects/education/youtube-clone-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "Youtube project's screenshot",
    link: "https://clone-theodinproject.web.app/",
    ...addProps(2022, 2022),
  },
  {
    name: "Find",
    about:
      "Find is a search-and-find game where a player searches an image for some items (e.g., Waldo, Cat, Apple, etc.). You finish the game by finding all the specified elements.",
    stack: "Firebase, Jest, ReactJS, Testing Library",
    imgSrc: new URL(
      "../images/projects/education/find-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "Find project's screenshot",
    link: "https://where-s-waldo-b7f36.web.app/",
    ...addProps(2022, 2022),
  },
  {
    name: "Battleship",
    about:
      "Battleship is a two-player game where players take turns to shoot each other's ships. The winner is the player who first sinks all their opponent's ships.",
    stack: "InteractJS, Jest, ReactJS, Testing Library",
    imgSrc: new URL(
      "../images/projects/education/battleship-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "Battleship project's screenshot",
    link: "https://oluwatobiss.github.io/battleship/",
    ...addProps(2021, 2022),
  },
  {
    name: "Transform.",
    about:
      "Transform is a shopping cart website where users browse for glamorous items to spark up their style. Use it to transform your clothing, jewelry, and electronic collections.",
    stack: "ReactJS, React Router, Fake Store API",
    imgSrc: new URL(
      "../images/projects/education/transform-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "Transform shopping cart project's screenshot",
    link: "https://oluwatobiss.github.io/shopping-cart",
    ...addProps(2021, 2021),
  },
  {
    name: "UniqPik",
    about:
      "UniqPik is a fun memory game. The objective is to attain your highest possible score by making unique card selections.",
    stack: "ReactJS, Pixabay API",
    imgSrc: new URL(
      "../images/projects/education/uniqpik-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "UniqPik project's screenshot",
    link: "https://oluwatobiss.github.io/memory-card",
    ...addProps(2021, 2021),
  },
  {
    name: "CV Builder",
    about:
      "CV Builder is an easy-to-use tool that provides an elegant way to showcase yourself.",
    stack: "ReactJS",
    imgSrc: new URL(
      "../images/projects/education/cv-builder-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "CV Builder project's screenshot",
    link: "https://oluwatobiss.github.io/cv-builder",
    ...addProps(2021, 2021),
  },
  {
    name: "OluWeather",
    about:
      "OluWeather is a weather app that allows you to stay updated with the weather condition of any city anywhere in the world.",
    stack: "HTML, CSS, JavaScript, Abstract API, OpenWeatherMap API",
    imgSrc: new URL(
      "../images/projects/education/oluweather-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "OluWeather project's screenshot",
    link: "https://oluwatobiss.github.io/weather-forecast/",
    ...addProps(2021, 2021),
  },
  {
    name: "My Plans",
    about:
      "A to-do list app that allows users to organize their day-to-day activities simply and effectively.",
    stack: "HTML, CSS, JavaScript, Webpack",
    imgSrc: new URL(
      "../images/projects/education/to-do-app-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "My Plans project's screenshot",
    link: "https://my-plans.netlify.app/",
    ...addProps(2021, 2021),
  },
  {
    name: "yummyFoods",
    about:
      "yummyFoods is a website people use to find varieties of yummy menus to satisfy their appetites. Use it to order delicious meals for yourself and your loved ones.",
    stack: "HTML, CSS, JavaScript, Webpack",
    imgSrc: new URL(
      "../images/projects/education/yummy-foods-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: `yummyFoods project's screenshot`,
    link: "https://yummy-foods-restaurant.netlify.app/",
    ...addProps(2020, 2021),
  },
  {
    name: "Tic Tac Toe",
    about:
      "A two-player game that allows each player to take a turn to mark a 3x3 grid with mark X or O. Play against a friend or the computer at various difficulty levels (easy, medium, or hard).",
    stack: "HTML, CSS, JavaScript",
    imgSrc: new URL(
      "../images/projects/education/tic-tac-toe-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "Tic Tac Toe project's screenshot",
    link: "https://oluwatobiss.github.io/tic-tac-toe/",
    ...addProps(2020, 2020),
  },
  {
    name: "My Library",
    about:
      "A library app that lets users keep a record of the books they want to read, the ones they are currently reading, and those they have read.",
    stack: "CSS, Firebase, HTML, JavaScript, Webpack",
    imgSrc: new URL(
      "../images/projects/education/library-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "My Library project's screenshot",
    link: "https://library-app-262e5.web.app/",
    ...addProps(2020, 2022),
  },
  {
    name: "Standard Calculator",
    about:
      "A standard calculator for calculating basic mathematical operations while adhering to the PEMDAS Operator Precedence. It works both with the keyboard and mouse.",
    stack: "HTML, CSS, JavaScript",
    imgSrc: new URL(
      "../images/projects/education/calculator-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "Standard Calculator project's screenshot",
    link: "https://oluwatobiss.github.io/calculator/",
    ...addProps(2020, 2020),
  },
  {
    name: "Etch-a-Sketch",
    about:
      "Etch-a-Sketch is a dynamic sketch pad allowing users to draw, write, customize the canvas, and define the pen color and activation mode.",
    stack: "HTML, CSS, JavaScript",
    imgSrc: new URL(
      "../images/projects/education/etch-a-sketch-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "Etch-a-Sketch project's screenshot",
    link: "https://oluwatobiss.github.io/etch-a-sketch/",
    ...addProps(2020, 2020),
  },
  {
    name: "The Rock - Paper - Scissors Game",
    about:
      "Rock-Paper-Scissors is a fun, easy game that allows you to make a decision versus the computer. You are to select an option (rock, paper, or scissors) that beats that of the computer.",
    stack: "HTML, CSS, JavaScript",
    imgSrc: new URL(
      "../images/projects/education/rock-paper-scissors-oluwatobi-sofela.png",
      import.meta.url
    ),
    imgAlt: "The Rock - Paper - Scissors project's screenshot",
    link: "https://oluwatobiss.github.io/rock-paper-scissors/",
    ...addProps(2020, 2020),
  },
];
